/*

Livingston 2020 General Scripts

*/


function initOnLoad(callbackFunc) {
	if (document.readyState !== 'loading') {
		// Document is already ready, call the callback directly
		callbackFunc();
	} else if (document.addEventListener) {
		// All modern browsers to register DOMContentLoaded
		document.addEventListener('DOMContentLoaded', callbackFunc);
	} else {
		// Old IE browsers
		document.attachEvent('onreadystatechange', function() {
			if (document.readyState === 'complete') {
				callbackFunc();
			}
		});
	}
}

/* Function called when document is loaded */
initOnLoad(function() {

	// initialise iFrameResize: /assets/scripts/vendor/iframe-resizer-master/js/iframeResizer.min.js
	iFrameResize({
		log                     : false,
		checkOrigin				: false,
		// heightCalculationMethod : "lowestElement"
	});

	// add other functions that need to be executed on DOMContentLoaded here...

});

/*
UTILITIES
-------------------------------------------------------------------------------
*/

/*
UTILITY: GET PAGE LANGUAGE
*/
function getLanguage() {
	if (/fr/i.test(document.documentElement.getAttribute('lang'))) {
		return 'fr';
	} else if (/sp/i.test(document.documentElement.getAttribute('lang'))) {
		return 'sp';
	} else {
		return 'en';
	}
}

const MathUtils = {
	// map number x from range [a, b] to [c, d]
	map: function (x, a, b, c, d) {
		return (x - a) * (d - c) / (b - a) + c;
	} ,
	// linear interpolation
	lerp: function (a, b, n) {
		n = n < 0 ? 0 : n;
		n = n > 1 ? 1 : n;
		return (1 - n) * a + n * b
	}
};

/*
UTILITY: SET / GET / DELETE COOKIE BY NAME
*/
function setCookieByName(cookiename, value) {
	let date = new Date();
	date.setTime(date.getTime() + (30 * 24 * 60 * 60 * 1000));
	const expires = "expires=" + date.toUTCString();
	document.cookie = cookiename + "=" + value + "; " + expires + "; path=/";
}
function getCookieByName(cookiename) {
	let cookiestring=RegExp(cookiename+"=[^;]+").exec(document.cookie);
	return decodeURIComponent(!!cookiestring ? cookiestring.toString().replace(/^[^=]+./,"") : "");
}
function deleteCookieByName(cookiename) {
	var d = new Date();
	d.setTime(d.getTime() - (1000 * 60 * 60 * 48));
	var expires = "expires=" + d.toGMTString() + '; ';
	document.cookie = cookiename + '=; Path=/; ' + expires;
}


/* Utility: parse querystring */
let match,
	pl     = /\+/g,  // Regex for replacing addition symbol with a space
	search = /([^&=]+)=?([^&]*)/g,
	decode = function (s) { return decodeURIComponent(s.replace(pl, " ")); },
	query  = window.location.search.substring(1);

// add liiUTM cookie (stored as querystring) to query if not present in querystring
if (query.indexOf('utm_') === -1) {
	let utm_cookie = getCookieByName('liiUTM');
	if (utm_cookie) {
		if (query) query += "&";
		query += utm_cookie;
	}
}

// convert querystring to root object
let urlParams = {};
if (query) {
	// get UTM querystring as object (same as URLSearchParams)
	while (match = search.exec(query))
		urlParams[decode(match[1])] = decode(match[2]);
}

